'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var DataExtractNewExtractController = function DataExtractNewExtractController($scope, $rootScope, constants, dataExtractService, validationService, ExtractConfig, SchedulerConfig, userManagementDataService, momentService, configService, userService) {
  _.assign($scope, constants);
  $scope.actionType = $scope.editedSchedule ? constants.ACTION_TYPES.UPDATE : constants.ACTION_TYPES.CREATE;
  $scope.editedSchedule = $scope.editedSchedule || {};
  $scope.extractConfig = {
    levels: [],
    appliedFilters: []
  };
  $scope.recurrenceIntervals = constants.RECURRENCE_INTERVALS;
  $scope.schedulerConfig = new SchedulerConfig($scope.editedSchedule.schedulerConfig);
  $scope.calendarIntervals = constants.CALENDAR_INTERVALS;
  $scope.daysOfMonth = constants.DAYS_OF_MONTH;
  $scope.isSummaryVisible = false;
  $scope.summaryMessage = '';
  $scope.availableFields = [];
  $scope.userList = [];
  $scope.hideSummary = function () {
    $scope.isSummaryVisible = false;
  };
  $scope.sendExtractData = function () {
    var newExtract = $scope.actionType === $scope.ACTION_TYPES.CREATE;
    if (!validationService.isValid($scope, newExtract)) {
      if ($scope.focusErrorMsg) {
        $scope.focusErrorMsg();
      }
      return;
    }
    var formData = {};
    $scope.extractConfig.getExtractFormData(formData);
    dataExtractService.run(formData);
  };
  $scope.sendExtractDataAndConfiguration = function () {
    var newExtract = $scope.actionType === $scope.ACTION_TYPES.CREATE;
    if (!validationService.isValid($scope, newExtract)) {
      if ($scope.focusErrorMsg) {
        $scope.focusErrorMsg();
      }
      return;
    }
    var formData = newFormData();
    fillFormData(formData);
    if ($scope.actionType === $scope.ACTION_TYPES.CREATE) {
      dataExtractService.schedule(formData);
    } else if ($scope.actionType === $scope.ACTION_TYPES.UPDATE) {
      dataExtractService.reschedule(formData);
    }
  };
  $scope.sendConfigurationData = function () {
    var newExtract = $scope.actionType === $scope.ACTION_TYPES.CREATE;
    if (!validationService.isValid($scope, newExtract)) {
      if ($scope.focusErrorMsg) {
        $scope.focusErrorMsg();
      }
      return;
    }
    var formData = newFormData();
    fillFormData(formData);
    if ($scope.actionType === $scope.ACTION_TYPES.CREATE) {
      dataExtractService.save(formData);
    } else if ($scope.actionType === $scope.ACTION_TYPES.UPDATE) {
      dataExtractService.update(formData);
    }
  };
  $scope.closeNewExtractScreen = function () {
    $rootScope.$broadcast('data-extract:activatePanel', 'scheduled');
  };
  $scope.onListBoxItemDblClicked = function (event, item) {
    $scope.$broadcast('data-extract:addAppliedFilter', item);
  };
  $scope.levelChanged = function () {
    $scope.extractConfig.extractFields = [];
    $scope.availableFields = _.filter($scope.extractConfig.level.fields, {
      hidden: false
    });
    $scope.$broadcast('data-extract:levelChanged');
  };
  function getCreatedByUser() {
    return $scope.editedSchedule.createdBy || configService.getUserId();
  }
  function getCreatedAt() {
    if ($scope.editedSchedule.createdAt) {
      return $scope.editedSchedule.createdAt.toISOString();
    }
    return momentService.now(momentService.FIELD.CREATED_AT).toISOString();
  }
  function newFormData() {
    return {
      createdBy: getCreatedByUser(),
      createdAt: getCreatedAt()
    };
  }
  function fillFormData(formData) {
    formData.exportConfig = $scope.extractConfig.getExtractFormData({});
    formData.schedulerConfig = $scope.schedulerConfig.getSchedulerFormData({});
    formData.lastUpdatedBy = configService.getUserId();
    formData.lastUpdatedAt = momentService.now(momentService.FIELD.LAST_UPDATED_AT).toISOString();
  }
  function assignLevelsAndTimeZoneCodes() {
    userManagementDataService.getTimeZoneCodes().then(function (data) {
      $scope.timezones = data.codes;
    });
    dataExtractService.getLevels().then(function (response) {
      $scope.extractConfig = new ExtractConfig(response.levels, $scope.editedSchedule.exportConfig, $scope.userList);
      if (!!$scope.extractConfig.level) {
        $scope.availableFields = _.filter($scope.extractConfig.level.fields, {
          hidden: false
        });
      }
    }, function (error) {
      var message = error.data && error.data.message || error.statusText || error.message;
      toastr.error(message);
    });
  }
  assignLevelsAndTimeZoneCodes();
  function getUsers() {
    userService.loadUserList().then(function (response) {
      if (response) {
        $scope.userList = response.map(function (user) {
          return user.userId + ' (' + user.firstName + ' ' + user.lastName + ')';
        });
      }
    });
  }
  getUsers();
};
DataExtractNewExtractController.$inject = ['$scope', '$rootScope', 'DataExtractConstants', 'DataExtractService', 'DataExtractValidationService', 'ExtractConfigFactory', 'SchedulerConfigFactory', 'UserManagementDataService', 'MomentService', 'ConfigurationService', 'UserSecureService'];
module.exports = DataExtractNewExtractController;